import { createAsyncThunk } from '@reduxjs/toolkit';
import { FAILURE_REASON, TYRO_PAYMENT_TOKEN_STATUS } from '../constants';
import { setSaleDetails } from '../reducers/currentOrder/saleDetails';
import { getSelectedPaymentMethods } from '../selectors';
import Api, { AuthenticationMethod, FetchParams } from '../utils/Api';
import determineSaleCharged from '../utils/determineSaleCharged';
import processSale from '../utils/processors/processSale';
import { duplicateSaleProtection } from './duplicateSaleProtection';
import { PAYMENT_METHOD } from '../constants/paymentMethod';
import Logger from '../utils/Logger';
import { setTyroPaymentStatus } from '../reducers/currentOrder/tyroPaymentStatus';

export const tyroSale = createAsyncThunk(
  '$tyroSale',
  async (
    data: {
      orderId: string;
      authenticationMethod?: AuthenticationMethod;
      shouldSetSaleDetails?: boolean;
    },
    { dispatch, rejectWithValue, getState },
  ) => {
    const { orderId, authenticationMethod, shouldSetSaleDetails } = data;

    let rawSale: RawSale | undefined;
    let charged: boolean | undefined;
    let initialResponse: any;
    let reason: FAILURE_REASON | undefined;

    const subPayments = getSelectedPaymentMethods(
      getState() as EntireFrontendState,
    );

    try {
      const path = `/api/v1/sale/payment_token_status/${orderId}`;
      const requestParams: FetchParams = {
        path,
        method: 'GET',
      };
      const response = await Api.fetch(requestParams);
      dispatch(setTyroPaymentStatus(response));

      initialResponse = response;

      if (response.success) {
        rawSale = response.Data;
        if (
          response.Status === TYRO_PAYMENT_TOKEN_STATUS.SUCCESS &&
          shouldSetSaleDetails
        ) {
          if (!rawSale) {
            throw new Error('missing sale details');
          }

          const processedSale = processSale(rawSale);
          dispatch(setSaleDetails(processedSale));
        }
      } else {
        Logger.log('-----  ----- Sale xx FAIL xx Response ----- ----', 'info');
        Logger.log(JSON.stringify(response), 'info');
        Logger.log('----- ----- ----- ----- ----- -----', 'info');

        //duplicate sale protection
        const saleProtection = await dispatch(
          duplicateSaleProtection({ authenticationMethod }),
        ).unwrap();

        if (saleProtection?.charged) {
          charged = saleProtection.charged;
        }

        throw new Error(response.error);
      }

      return response;
    } catch (e) {
      if ((e as any).message === 'Verify PIN does not match') {
        reason = FAILURE_REASON.BAD_GIFT_CARD;
      }

      const chargeStarted = subPayments?.some(subPayment => {
        if (PRE_CHARGE_METHODS.includes(subPayment.method)) {
          return true;
        }
      });

      if (charged !== false) {
        charged = determineSaleCharged(initialResponse);
      }

      Logger.log(
        '==> @RedcatApiHandler: Something may have gone wrong',
        'info',
      );
      Logger.log(
        JSON.stringify({
          e,
          charged,
          chargeStarted,
          reason: reason ? reason : (e as any).message,
        }),
        'info',
      );

      return rejectWithValue({
        e,
        charged,
        chargeStarted,
        reason: reason ? reason : (e as any).message,
      });
    }
  },
);

const PRE_CHARGE_METHODS = [
  PAYMENT_METHOD.APPLE_PAY,
  PAYMENT_METHOD.GOOGLE_PAY,
  PAYMENT_METHOD.CREDIT_CARD,
  PAYMENT_METHOD.EFTPOS,
];
